export type Filter = "all" | "comments" | "runs" | "tracker";

export const FILTERS: Array<{ value: Filter; label: string }> = [
  { value: "all", label: "All" },
  { value: "comments", label: "Notes" },
  { value: "runs", label: "Runs" },
  { value: "tracker", label: "Tracker" },
];

export interface Entry {
  id: string;
  source: "stored" | "run";
  kind: string;
  actorKind: string;
  actorId: string | null;
  actorName: string | null;
  fromState: string | null;
  toState: string | null;
  reason: string | null;
  body: string | null;
  payload: Record<string, unknown> | null;
  walkthroughId: string | null;
  createdAt: string;
  editedAt: string | null;
}

export interface ProjectMemberItem {
  id: string;
  userId: string;
  role: string;
  displayName: string | null;
  avatarUrl?: string | null;
}
